import { render, staticRenderFns } from "./CohortPage.vue?vue&type=template&id=736d37fa"
import script from "./CohortPage.vue?vue&type=script&lang=js"
export * from "./CohortPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports